<template>
	<div class = "test">
		<sideBar></sideBar>
	</div>
</template>

<script>
	import sideBar from "@/components/comHtml/sideBar"
	export default {
		name: 'test',
		data() {
			return {
			}
		},
		components: {
			sideBar
		},
		created: function() {
		},
		mounted: function() {
		},
		methods: {
		}

	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/assets/test.vue